<template>
  <Modal
    :show="show.deleteApprovalTemplate"
    width="small"
    @close="close"
  >
    <template #title>
      Delete this approval template?
    </template>

    <template #content>
      <div>
        This approval template will be permanently deleted.
      </div>

      <div class="mt-3">
        It will no longer be available when creating new approval flows.
        Existing approval flows that use this template will not be affected.
      </div>
    </template>

    <template #actions>
      <v-spacer />

      <v-btn
        variant="flat"
        color="error"
        size="small"
        rounded="lg"
        class="text-button-2"
        @click="confirm"
      >
        Delete
      </v-btn>
    </template>
  </Modal>
</template>

<script setup>
import { storeToRefs } from 'pinia';
import { useModals } from '@/stores/modals/modals';
import Modal from '@/components/shared/Modal.vue';

defineOptions({ name: 'TemplateDeleteModal' });

const emit = defineEmits(['delete']);

const { show } = storeToRefs(useModals());
const { setModal } = useModals();

const close = () => setModal({ field: 'deleteApprovalTemplate', value: false });

const confirm = () => {
  close();
  emit('delete');
};
</script>
